import { isEmpty, isNil } from 'lodash';

import { CONTRACT_TYPE, EXPENSES } from '../../../../shared/constants';
import { IMultiSelectDropDownOption } from '../../../___design/MultiSelectDropDownInput/MultiSelectDropDownInput.types';
import { IListingDetailForm } from '../ListingDetailForm.types';

type IListingDetailFormKey = keyof IListingDetailForm;

const RequiredFieldForTenants: {
  label: string;
  value: IListingDetailFormKey;
}[] = [
  { label: 'listingDetail:typeOfContract', value: 'contract_type' },
  {
    label: 'listingDetail:reasonForTemporaryContract',
    value: 'contract_landlord_reason',
  },
  { label: 'listingDetail:typeOfTax', value: 'contract_tax_type_flat' },
  { label: 'listingDetail:portionOfProperty', value: 'property_type' },
  { label: 'listingDetail:typeOfAgreement', value: 'rental_agreement' },
  { label: 'listingDetail:animals', value: 'pets_allowed' },
  { label: 'listingDetail:students', value: 'allow_students' },
  { label: 'listingDetail:expensesIncluded', value: 'rent_expense' },
  { label: 'listingDetail:tenantWillChangeTheNameOn', value: 'tenant_expense' },
  { label: 'listingDetail:tenantWillPayTheLandord', value: 'landlord_expense' },
  {
    label: 'listingDetail:maximumNumberOfTenants',
    value: 'max_number_of_guests',
  },
];

export const filterRequiredFieldForHouseInformation = ({
  values,
}: {
  values: IListingDetailForm;
}) => {
  const expensesFields: Array<keyof IListingDetailForm> = [
    'rent_expense',
    'tenant_expense',
    'landlord_expense',
  ];

  const sumOfExpenses = expensesFields.reduce((sum, expenseField) => {
    const fieldValues =
      (values[expenseField] as IMultiSelectDropDownOption[]) || [];
    return sum + fieldValues.length;
  }, 0);

  const hasAllExpenses = sumOfExpenses === Object.values(EXPENSES).length;

  const emptyFields = RequiredFieldForTenants.filter(field => {
    const contractType = values['contract_type']?.value;
    if (field.value === 'contract_landlord_reason') {
      return contractType === CONTRACT_TYPE.TEMPORARY.value
        ? !values['contract_landlord_reason']
        : false;
    }

    if (expensesFields.includes(field.value as keyof IListingDetailForm)) {
      // Skip the field if hasAllExpenses is true
      return !hasAllExpenses;
    }

    if (field.value === 'max_number_of_guests') {
      return !Number(values[field.value]);
    }
    return isEmpty(values[field.value]) || isNil(values[field.value]);
  }).map(field => field.label);

  const label = 'listingDetail:contractInfo';

  return {
    label,
    fields: emptyFields,
  };
};
